<script setup lang="ts">
// Phase 0 shell. Replaced wholesale in phase 1 by the design system and the
// application shell described in spec §9 and §10.1.
//
// The APP_NAME import is deliberate: it proves @dws/shared's buildless
// source-exports pattern resolves through Vite, which is otherwise not
// exercised until phase 1.
//
// Imported from the narrow subpath, not the barrel: the barrel re-exports the
// zod config schema, which a browser bundle must never carry. See
// packages/shared/src/branding.ts and apps/web/src/bundle.test.ts.
import { APP_NAME } from '@dws/shared/branding'

const title = APP_NAME
const subtitle = 'Back Office'
const marker = 'Phase 0 — deployed by CI'
</script>

<template>
  <main>
    <h1>{{ title }}</h1>
    <p>{{ subtitle }}</p>
    <p>{{ marker }}</p>
  </main>
</template>

<style>
body {
  margin: 0;
  font-family: system-ui, sans-serif;
}
main {
  padding: 48px;
}
</style>
